module.exports = __webpack_public_path__ + "static/img/image_recruit_06.e5e06b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/join/image_recruit_06.png
// module id = LC/2
// module chunks = 10